import React, { useState as _useState } from 'react'
import './index.less'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@/hooks'
import { setShowWorkId as _setShowWorkId } from '@/features/SetShowWorkId/setShowWorkId'
import { SRC_URL } from '@/server'

export function PaintingCard(props) {
  const { title, image, dynasty, author, museum, id, similarity } = props
  const _dispatch = useAppDispatch()
  const _navigate = useNavigate()
  function handleClick() {
    window.open('/details/' + id + '/null')
  }
  return (
    <div className='painting-card-container'>
      <div className='painting-card' onClick={() => handleClick()}>
        <div className='painting-container'>
          <img src={`${SRC_URL}${image}`} />
        </div>
        <div className='painting-mask'>
          <div className='mask-title' title={title ?? ''}>
            <div className='title-name'>{title ?? ''}</div>
            <div className='title-similarity'>{similarity ?? ''}</div>
          </div>
          <div className='mask-subtitle'>
            <div
              className='dynasty-author'
              title={`${dynasty || ''}${
                Boolean(dynasty) === true && Boolean(author) === true ? '｜' : ''
              }${author || ''}`}
            >
              {dynasty || ''}
              {Boolean(dynasty) === true && Boolean(author) === true ? '｜' : ''}
              {author || ''}
            </div>
            <div className='museum' title={museum || ''}>
              {museum || ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
